// lot store inner constants
export const GET_CURFOLDER = 'curentFileFolderGet';

export const ACT_CURFOLDERSET = 'curentFileFolderSet';

export const MUT_CURFOLDERSET = 'curentFileFolderMut';
